// components/CMSLink.tsx
import React, { forwardRef, AnchorHTMLAttributes } from 'react';
// eslint-disable-next-line no-restricted-imports
import Link, { LinkProps } from 'next/link';
import { useFranchise } from '~/shared/utils';

type Props = Partial<LinkProps> & AnchorHTMLAttributes<HTMLAnchorElement>;

const CMSLinkComponent = forwardRef<HTMLElement, Props>((props, ref) => {
    const { href, children, className, style, locale, onClick, ...rest } = props;

    const { isMultiCultural } = useFranchise();

    if (href || onClick) {
        return (
            <Link
                href={href || ''}
                className={className}
                {...(onClick && { onClick })}
                style={style}
                ref={ref as React.Ref<HTMLAnchorElement>}
                locale={isMultiCultural ? locale : false}
                {...rest}
            >
                {children}
            </Link>
        );
    }

    return (
        <div className={className} style={style} ref={ref as React.Ref<HTMLDivElement>}>
            {children}
        </div>
    );
});

const CMSLink = React.memo(CMSLinkComponent);
CMSLink.displayName = 'CMSLink';

export { CMSLink };
